import React, { useState, useEffect } from 'react';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import RequestHandler from './RequestHandler';
import configurationService from '../../services/ConfigurationsServices';
import { toast, ToastContainer } from 'react-toastify';

const ModuleSettings = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await configurationService.getAllModules(); 
        setModules(response.data.data);
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message || "An error occurred");
        console.error('Error fetching modules:', error);
      }
    };

    fetchModules();
  }, []);
  const handleChange = (e) => {
    const { name, type, checked } = e.target;

    if (modules.some(module => module.name === name)) {
      // If the checkbox is for a parent module
      setFormData(prevFormData => {
        const updatedFormData = { ...prevFormData, [name]: checked };
        // Enable/disable all child checkboxes based on the parent checkbox
        const module = modules.find(module => module.name === name);
        if (module.child) {
          module.child.forEach(child => {
            updatedFormData[child] = checked; // Set child checkbox state based on parent
          });
        }
        return updatedFormData;
      });
    } else {
      // If the checkbox is for a child module
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: type === 'checkbox' ? checked : e.target.value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const requestBody = await RequestHandler(formData, "Module Settings", "Module", null, true);
      console.log(requestBody)

      await configurationService.createConfiguration(requestBody); 

      console.log('Form submitted:', requestBody);
    } catch (error) {
      console.error('Submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-10 col-xl-12">
              <PageHeader title="Module Settings" />
              <div className="card p-4">
                <form onSubmit={handleSubmit}>
                  {modules.map((module) => (
                    <div className="form-group" key={module.name}>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name={module.name}
                          checked={formData[module.name] || false}
                          onChange={handleChange}
                          id={module.name}
                        />
                        <label className="form-check-label" htmlFor={module.name}>
                          <h3>{module.name}</h3>
                        </label>
                      </div>

                      {module.child && module.child.length > 0 && (
                        <ul className="ms-4" style={{ listStyleType: 'none', padding: 0 }}> 
                          {module.child.map((child) => (
                            <li key={child}>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={child}
                                  checked={formData[child] || false}
                                  onChange={handleChange}
                                  id={child}
                                />
                                <label className="form-check-label" htmlFor={child}>
                                  {child}
                                </label>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                      <hr />
                    </div>
                  ))}

                  <div className="mt-4">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Saving...' : 'Save'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ModuleSettings;
